module.exports = "<div fxLayout=\"column\" fxLayoutAlign=\"start start\">\n  <p class=\"mat-subheading-1\">\n    {{card.answer}}\n  </p>\n  <img [src]=\"'assets/images/' + card.id.toString() + '.png'\" *ngIf=\"card.answerImage\">\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/remote/card/answer/card-answer.component.html
// module id = ./src/app/remote/card/answer/card-answer.component.html
// module chunks = main